
import React from 'react';
import { PageSection } from '../../../types';
import { Star, Coffee, PiggyBank, Smartphone, Truck, Heart, ShieldCheck, Zap, Smile, ThumbsUp, Award, Clock, Globe } from 'lucide-react';

// Säkrare ikon-mappning än dynamisk import
const ICON_MAP: Record<string, any> = {
    Star, Coffee, PiggyBank, Smartphone, Truck, Heart, ShieldCheck, Zap, Smile, ThumbsUp, Award, Clock, Globe
};

interface FeaturesSectionProps {
    section: PageSection;
}

export const FeaturesSection: React.FC<FeaturesSectionProps> = ({ section }) => {
    // Säkerställ att vi har data att visa
    if (!section.features || section.features.length === 0) {
        return (
            <div className="py-12 bg-background text-center">
                <p className="text-stone-400 italic text-sm">Inga punkter tillagda i Features-sektionen än.</p>
            </div>
        );
    }

    return (
        <div className="py-20 px-6 bg-background">
            <div className="max-w-7xl mx-auto">
                {(section.title || section.text) && (
                    <div className="text-center max-w-3xl mx-auto mb-16 animate-fade-in-up">
                        {section.title && (
                            <h2 className="text-3xl font-heading font-bold text-primary mb-6">
                                {section.title}
                            </h2>
                        )}
                        {section.text && (
                            <p className="text-lg text-secondary leading-relaxed font-light opacity-90">
                                {section.text}
                            </p>
                        )}
                    </div>
                )}
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                    {section.features.map((feature, idx) => {
                        // Välj ikon säkert, fall tillbaka på 'Star' om den saknas
                        const IconComponent = ICON_MAP[feature.icon] || Star;
                        
                        return (
                            <div key={idx} className="text-center group animate-fade-in-up" style={{ animationDelay: `${idx * 100}ms` }}>
                                <div className="w-16 h-16 bg-accent-soft rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:bg-secondary group-hover:text-white transition-all duration-300 shadow-sm group-hover:shadow-md group-hover:-translate-y-1">
                                    <IconComponent size={32} strokeWidth={1.5} />
                                </div>
                                <h3 className="text-xl font-bold text-primary mb-3">{feature.title}</h3>
                                <p className="text-secondary leading-relaxed">{feature.text}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
